var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"}},[_c('rect',{attrs:{"stroke":_vm.$gui.iconPositiveColor,"x":"0.5","y":"0.5","width":"17","height":"13","rx":"2.5"}}),_c('rect',{attrs:{"fill":_vm.$gui.iconPositiveColor,"y":"4","width":"18","height":"3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }